import qs from "qs";
import { toLanguageCountryName } from "src/common/l10n/country-utils";
import logger from "src/logger";

//DOC to update params to generate PayPal URL: https://developer.paypal.com/docs/checkout/reference/customize-sdk/

const PAYPAL_URL = "https://www.paypal.com/sdk/js";

export const buildPaypalSdkUrl = (
  clientId,
  country,
  appendPayLaterParams,
  commitParam = false
) => {
  if (!PAYPAL_URL) {
    logger.error(
      `Paypal checkout failed: unable to build Paypal SDK url as base url was missing.`
    );
    return null;
  }
  if (!clientId) {
    logger.error(
      `Paypal checkout failed: unable to build Paypal SDK url as client id was missing.`
    );
    return null;
  }
  if (!country || !country.currency) {
    logger.error(
      `Paypal checkout failed: unable to build Paypal SDK url as country was not valid.`,
      {
        country,
        clientId,
      }
    );
    return null;
  }

  const currency = country.currency;
  const locale = toLanguageCountryName(country, "_");

  const basicParams = qs.stringify(
    {
      intent: "authorize",
      "client-id": clientId,
      locale,
      currency,
      "disable-funding": "card,sofort",
    },
    { addQueryPrefix: true }
  );

  if (!appendPayLaterParams) {
    return `${PAYPAL_URL}${basicParams}`;
  }

  const payLaterParams = qs.stringify({
    // DOC for commit value:
    // https://developer.paypal.com/docs/checkout/reference/customize-sdk/#commit
    commit: commitParam,
    "enable-funding": "paylater",
    components: "messages,buttons",
  });

  return `${PAYPAL_URL}${basicParams}&${payLaterParams}`;
};
